import { PipelineConfig } from '../config-types';
import { FrameData } from '../generator';
import { compileShader, linkProgram } from '../util';

import { LadonRenderer } from './ladon-renderer';
import { WebGLRenderer } from './webgl-renderer';

export class PassthroughRenderer extends WebGLRenderer implements LadonRenderer {
    private program: WebGLProgram;

    private fragment_shader = `#version 300 es
precision highp float;

out vec4 outColor;

uniform sampler2D       u_image;
uniform vec2            u_resolution;


void main() {
    ${this.getUVCalculation()}

    outColor = vec4(texture(u_image, st).rgb, 1.0);
}
`;

    constructor(public output_canvas: HTMLCanvasElement, public readonly config: PipelineConfig) {
        super(output_canvas, config);

        const vertex_shader = compileShader(this.gl, this.gl.VERTEX_SHADER, this.vertex_shader_src);
        const fragment_shader = compileShader(
            this.gl,
            this.gl.FRAGMENT_SHADER,
            this.fragment_shader
        );

        this.program = linkProgram(this.gl, vertex_shader, fragment_shader);
        this.gl.useProgram(this.program);

        this.setSharedUniforms(this.program);
    }

    public async render(input: FrameData): Promise<void> {
        this.uploadVideoStream(input);

        this.gl.useProgram(this.program);

        this.gl.drawArrays(this.gl.TRIANGLES, 0, this.verts.length / 3);

        this.postDraw();
    }

    public async load(): Promise<void> {
        // empty
    }

    public destroy(): void {
        // empty
    }
}
